import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import type {
  UnlockProModeMutation,
  UnlockProModeMutationVariables,
} from './__generated__/useUnlockProMode.graphql.ts';
import { useMutation } from './graphql/useMutation.ts';

const UNLOCK_PRO_MODE_MUTATION = gql`
  mutation UnlockProModeMutation($input: unlockProModeInput!, $sport: Sport!) {
    unlockProMode(input: $input) {
      currentUser {
        slug
        anyUserSportProfile(sport: $sport) {
          id
          proUnlocked
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<UnlockProModeMutation, UnlockProModeMutationVariables>;

export const useUnlockProMode = () => {
  const { currentUser } = useCurrentUserContext();
  const [unlockProMode, { loading }] = useMutation(UNLOCK_PRO_MODE_MUTATION, {
    showErrorsWithSnackNotification: true,
    optimisticResponse: {
      unlockProMode: {
        __typename: 'unlockProModePayload',
        currentUser: {
          __typename: 'CurrentUser',
          slug: currentUser?.slug || '',
          anyUserSportProfile: {
            __typename: 'FootballUserSportProfile',
            id: currentUser?.anyUserSportProfile?.id || '',
            proUnlocked: true,
          },
        },
        errors: [],
      },
    },
  });

  return { unlockProMode, loading };
};
